import { EProblemReportStatus } from '@constants';
import { useState } from 'react';

import { ProblemReportStatus } from '../ProblemReportStatus';
import { SolveReportAndSendMessageModal } from '../SolveReportAndSendMessageModal';

import { StatusContainer } from './ProblemReportStatusSelector.styled';

import { useMutateProblemReports } from '@/store';

interface Props {
  problemReportId: string;
  reportId: string;
  userName: string;
  activityName: string;
  onStatusChange?: () => void;
}

export const ProblemReportStatusSelector: React.FC<Props> = ({
  problemReportId,
  reportId,
  userName,
  activityName,
  onStatusChange
}) => {
  const { updateStatus, isWorking } = useMutateProblemReports();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const changeStatus = (newStatus: EProblemReportStatus) => {
    if (newStatus === EProblemReportStatus.REVIEWED) {
      setIsModalOpen(true);
      return;
    }

    updateStatus(
      { _id: problemReportId, reportId, newStatus },
      { onSuccess: () => onStatusChange?.() }
    );
  };

  const handleResolveConfirm = (message: string) => {
    updateStatus(
      { _id: problemReportId, reportId, newStatus: EProblemReportStatus.REVIEWED, message },
      {
        onSuccess: () => {
          setIsModalOpen(false);
          onStatusChange?.();
        }
      }
    );
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {Object.values(EProblemReportStatus).map(status => (
        <StatusContainer key={status}>
          <ProblemReportStatus status={status} onClick={changeStatus} />
        </StatusContainer>
      ))}

      <SolveReportAndSendMessageModal
        open={isModalOpen}
        userName={userName}
        activityName={activityName}
        onConfirm={handleResolveConfirm}
        onCancel={handleModalCancel}
        isLoading={isWorking}
      />
    </>
  );
};
